import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-play-icon',
  templateUrl: './play-icon.component.html',
  styleUrls: ['./play-icon.component.scss'],
})
export class PlayIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
